import { createContext } from 'react';

import { ModuleState } from 'core/dna/types/local';

export const SelectedModuleStateContext = createContext<ModuleState | null>(
  null,
);

SelectedModuleStateContext.displayName = 'SelectedModuleState Context';
